import SuperTokens from 'supertokens-web-js';
import EmailVerification from "supertokens-web-js/recipe/emailverification"
import EmailPassword from "supertokens-web-js/recipe/emailpassword"
import Session from "supertokens-web-js/recipe/session"

import { Action } from "src/state/_types";
import logger from 'src/utils/logger';

export const initializeAuth: Action = async ({ actions }) => {

    logger(`Initializing Auth`)

    SuperTokens.init({
        appInfo: {
            appName: import.meta.env.VITE_APP_NAME || '',
            apiDomain: import.meta.env.VITE_AUTH_API_HOST || ''
        },
        recipeList: [
            EmailVerification.init({}),
            EmailPassword.init({}),
            Session.init({
                onHandleEvent: async (context) => {
                    logger(`Session.onHandleEvent: [${context.action}]`, null, 'info')
                    if (context.action === 'SESSION_CREATED' || context.action === 'REFRESH_SESSION') {
                        await actions.refreshSession()
                        actions.initializeApi()
                        await actions.getProfile()
                        await actions.initializeSubscriptions()
                    }
                }
            })
        ]
    })

}